// extracted by mini-css-extract-plugin
module.exports = {"styles":"pQ4b3S5eJGoZhFPm-Lx_X"};